module.exports = __webpack_public_path__ + "img/langosta_al_ajillo.971fea04.jpg";